import navigation from "@/lang/pt_BR/navigation";
import generics from "@/lang/pt_BR/generics";
import questions from "@/lang/pt_BR/questions";
import a11y from "@/lang/pt_BR/a11y";
import velt from "@/lang/pt_BR/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}